module.exports = __webpack_public_path__ + "img/icons-fill-operation-saphhire.81076f71.svg";